import * as mainActionTypes from '../mainActionTypes';

export function setNamesList(ideas) {
  return {
    type: mainActionTypes.SET_NAMES_LIST,
    payload: ideas
  };
}

export function findDomain(nameAfterEdit, indexEdited) {
  return {
    type: mainActionTypes.FIND_DOMAIN,
    payload: { nameAfterEdit, indexEdited }
  };
}

export function likedName(nameIndex) {
  return {
    type: mainActionTypes.LIKED_NAME,
    payload: nameIndex
  };
}

export function removeName(nameIndex) {
  return {
    type: mainActionTypes.REMOVE_NAME,
    payload: nameIndex
  };
}

export function sortNames(typeOfSorting) {
  return {
    type: mainActionTypes.SORT_NAMES,
    payload: typeOfSorting
  };
}
